var apexConfig = {
    apiIp: 'https://apexdev.chiaofu.com',
    //apiIp: 'http://localhost:51441',
    //apiIp: 'https://apex.chiaofu.com',
    //apiIp: 'http://10.1.1.48:9005',
}

module.exports = apexConfig;